import {useState} from "react";
import {globalMessageHandler, Rules, ValidationErrors, Validator} from "common";
import I18n from "i18n-js";
import {PasswordRecoveryRequestForm} from "./passwordRecoveryRequestAPI";
import {useNavigate} from "react-router-dom";
import {values} from "lodash";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {passwordRecoveryRequestAsync, selectIdentityStatus} from "../../../identitySlice";

export interface PasswordRecoveryRequestFormProps {
  defaultValues?: PasswordRecoveryRequestForm;
  onRequestSent: Function;
}

export function validatePasswordRecoveryRequest(values: PasswordRecoveryRequestForm) {
  const rules: Rules = {
    email: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "PasswordRecoveryRequest");
}

export default function usePasswordRecoveryRequestForm({defaultValues, onRequestSent}: PasswordRecoveryRequestFormProps) {
  const [item, setItem] = useState<PasswordRecoveryRequestForm>(
    defaultValues || ({} as PasswordRecoveryRequestForm)
  );
  const [errors, setErrors] = useState<ValidationErrors>({});
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectIdentityStatus);
  const navigate = useNavigate();

  function onChange(values: PasswordRecoveryRequestForm) {
    setItem(values);
  }

  async function process() {
    const result = validatePasswordRecoveryRequest(item);
    setErrors(result.errors);

    if (!result.success) {
      return;
    }

    const response = await dispatch(passwordRecoveryRequestAsync(item));

    if (response.meta.requestStatus === "fulfilled") {
      onRequestSent(item.email);
    } else {
      if (response.payload) {
        setErrors({
          email: response.payload.form_errors['email'][0],
        });
      }
    }
  }

  return {
    item,
    errors,
    loading: status === "loading",
    process,
    onChange,
  };
}